import { defineComponent as _defineComponent } from 'vue';
import ObjectStoreBadge from "./ObjectStoreBadge.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ObjectStoreBadges',
    props: {
        badges: null,
        size: { default: "3x" },
        moreOnHover: { type: Boolean, default: true }
    },
    setup(__props) {
        return { __sfc: true, ObjectStoreBadge };
    }
});
